import React from 'react';
import { Chip, Typography } from '@mui/material';
import { DynamicModuleUiModuleBody } from '../../../../../API';
import { useLocales } from '../../../../../hooks';
import { useSchemaCatalog, useSchemaName } from '../../../../../hooks/Config/useSchemaCatalog';
import UIModuleListItem, { IBaseUIModuleListItemProps } from '../../UIModuleListItem';

export type DynamicModuleListItemProps = IBaseUIModuleListItemProps<DynamicModuleUiModuleBody>;

const DynamicModuleListItem = ({ uiModule, ...props }: DynamicModuleListItemProps): JSX.Element => {
  const { t } = useLocales();
  useSchemaCatalog();
  const schemaName = useSchemaName(uiModule.schemaId || '');

  return (
    <UIModuleListItem
      uiModule={uiModule}
      topLineTitle={t('layouts.ui_module_dynamic_module')}
      topLine={[
        <>
          <Typography variant="body2" color="textSecondary">
            {t('layouts.dynamic_module.schema_label')}
          </Typography>
          <Chip label={schemaName || uiModule.schemaId || '—'} size="small" />
        </>
      ]}
      {...props}
    />
  );
};

export default DynamicModuleListItem;
